import React, { useState } from 'react'
import { gql, useQuery } from '@apollo/client'
import { Input, Button, Alert, Progress, Popover, PopoverHeader, PopoverBody } from "reactstrap"
import Select from 'react-select'
import { CarTypeAhead, DriverTypeAhead, RepsTypeAhead, IncidentTypeAhead, CarIssuesTypeAhead } from "./TypeAheadComponents"
import { UpdateTaskMutation } from "../Mutations"
import StatusDropDown from "./Components"
import withApolloClient from '../../withApolloClient'
import "./EditTaskPopOver.css"

const ColumnQuery = gql`query ColumnQuery($columnId: ID!){
    column(id: $columnId){
        id
        title
        columnType
        elementType
        allowedOptions
        contentType{
            id
            appLabel
            model
        }
    }
}`

function EditTaskPopOver({ isOpen, task, closeModal, target, title, name, value, type, maxLength, columnId, ...props }) {
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)
    const [input, setInput] = useState({})

    const { data: columnData, loading: columnLoading, error: columnError } = useQuery(
        ColumnQuery,
        {
            variables: { columnId: columnId },
            fetchPolicy: 'network-only',
            skip: !columnId,
        }
    )

    const editTask = (e) => {
        e.preventDefault()
        try {
            // const { client } = this.props
            if (!props.apolloClient || !task.id) {
                throw new Error("GQL Client not found")
            }

            let queryInput = { taskId: task.id, ...input }
            if (Object.keys(input).length === 0) {
                return
            }
            setLoading(true)
            props.apolloClient.mutate({
                mutation: UpdateTaskMutation,
                refetchQueries: ["AllTasks"],
                variables: { input: queryInput },
            }).then((result) => {
                setLoading(false)
                if (!result) {
                    throw new Error("Error creating task")
                }
                if (result.data && result.data.updateTask && result.data.updateTask.ok) {
                    setError("")
                    closeModal("")
                } else {
                    const errorMessage = result.data && result.data.updateTask && result.data.updateTask.errors && result.data.updateTask.errors.messages ? result.data.updateTask.errors.messages[0] : "Unknown Error"
                    throw new Error(errorMessage)
                }
            }).catch((error) => {
                setError("Error creating task" + error.toString())
                setLoading(false)
            })
        } catch (error) {
            console.log("Error creating task", error)
            setError("Error creating task" + error.toString())
            setLoading(false)
        }
    }

    const renderColumnInput = () => {
        if (columnLoading || columnError) {
            return <Progress animated color="info" value={100} />
        }
        if (columnData.column.columnType === "FK_OBJECT") {
            return columnData.column.contentType.model === "driver" ? <DriverTypeAhead defaultValue={value} onChange={(value) => setInput({ ...input, columnValues: [{ columnId: columnId, value: value }] })} />
                : columnData.column.contentType.model === "car" ? <CarTypeAhead defaultValue={value} onChange={(value) => setInput({ ...input, columnValues: [{ columnId: columnId, value: value }] })} />
                    : columnData.column.contentType.model === "incident" ? <IncidentTypeAhead defaultValue={value} onChange={(value) => setInput({ ...input, columnValues: [{ columnId: columnId, value: value }] })} />
                        : columnData.column.contentType.model === "carissues" ? <CarIssuesTypeAhead defaultValue={value} onChange={(value) => setInput({ ...input, columnValues: [{ columnId: columnId, value: value }] })} />
                            : null
        } else if (columnData.column.columnType === "ENUM") {
            const options = (columnData.column.allowedOptions || []).map(opt => ({ value: opt, label: opt }))
            return <Select
                options={options}
                defaultValue={value ? { value, label: value } : null}
                onChange={(selected) => setInput({ ...input, columnValues: [{ columnId: columnId, value: selected ? selected.value : "" }] })}
                isClearable
            />
        } else if (columnData && columnData.column && columnData.column.columnType === "LIST") {
            return <Input autoComplete={"off"} type={columnData.column.columnType} maxLength={maxLength ? maxLength : 200} name={name} id={name} defaultValue={value} placeholder={title} onChange={(e) => { setInput({ ...input, columnValues: [{ columnId: columnId, value: e.target.value }] }) }} />
        } else if (columnData?.column?.columnType === "URL") {
            return <Input autoComplete={"off"} type="url" maxLength={maxLength ? maxLength : 500} name={name} id={name} defaultValue={value} placeholder="https://..." onChange={(e) => { setInput({ ...input, columnValues: [{ columnId: columnId, value: e.target.value }] }) }} />
        } else {
            return <Input autoComplete={"off"} type={columnData?.column?.columnType || "text"} maxLength={maxLength ? maxLength : 200} name={name} id={name} defaultValue={value} placeholder={title} onChange={(e) => { setInput({ ...input, columnValues: [{ columnId: columnId, value: e.target.value }] }) }} />
        }
    }

    return (
        <Popover trigger="legacy" placement="bottom" isOpen={isOpen} target={target} toggle={() => closeModal("")} className={`popover-custom-width ${name === "status" ? "status-editor-popover" : ""}`}>
            {name !== "status" && <PopoverHeader onClick={() => closeModal("")}>{title} <i style={{ float: "right" }} className="fa fa-times-circle" aria-hidden="true"> </i></PopoverHeader>}
            <PopoverBody className={name === "status" ? "status-editor-body" : ""} style={name === "status" ? {} : { textAlign: "center" }}>
                {error && <Alert color="danger">{error}</Alert>}
                <div className='pb-2'>
                    {columnId ? (
                        renderColumnInput()
                    ) : name === "assignedToIds" ?
                        <RepsTypeAhead onChange={(value) => setInput({ ...input, assignedToIds: value })} defaultValue={value} />
                        : name === "status" ?
                            <StatusDropDown taskStatus={task.status} taskId={task.id} isAutomated={task.isAutomated} client={props.apolloClient} closeModal={closeModal} />
                            : type === "boolean" ? <div>
                                <span>Yes</span>
                                <div className="toggle-switch">
                                    <input type="checkbox" className="toggle-switch-checkbox" name={name} id={"taskEdit"} checked={!input[name]} onChange={() => setInput({ [name]: !input[name] })} />
                                    <label className="toggle-switch-label" htmlFor={"branchInfo"}>
                                        <span className="toggle-switch-inner" />
                                        <span className="toggle-switch-switch" />
                                    </label>
                                </div>
                                <span>No</span>
                            </div>
                                : <Input autoComplete={"off"} type={type} maxLength={maxLength ? maxLength : 200}
                                    name={name} id={name} defaultValue={value}
                                    placeholder={title} onChange={(e) => {
                                        setInput({ [name]: e.target.value })
                                        if (name === "dueDate" && error) {
                                            setError(null)
                                        }
                                    }}
                                // min={name === "dueDate" ? new Date().toISOString().split("T")[0] : undefined}
                                />
                    }
                    {loading ? (<Progress animated color="info" value={100} />) : (name === "status" ? null : (
                        <Button className="float-right submit-button my-2 py-1" type="button" size="sm" onClick={editTask} disabled={error || loading}>Submit</Button>)
                    )}
                </div>
            </PopoverBody>
        </Popover>
    )
}

export default withApolloClient(EditTaskPopOver)
